import React from 'react';

import { MenuReorderCard } from 'features/menu/components/menu-reorder-widget/menu-reorder-card';
import { contentStyles } from 'features/menu/components/menu-reorder-widget/menu-reorder-details-drawer/styled';
import { MenuReorderDetailsDrawerProps } from 'features/menu/components/menu-reorder-widget/menu-reorder-details-drawer/types';
import { MenuReorderItemsList } from 'features/menu/components/menu-reorder-widget/menu-reorder-items-list';
import { View } from 'react-native';

import { BottomSheet } from 'components/bottom-sheet';

export const MenuReorderDetailsDrawer = ({
  showDrawer,
  toggleDetailsDrawer,
  order,
  openDetailEventMessage,
}: MenuReorderDetailsDrawerProps) => {
  return (
    <BottomSheet
      onOpenEventMessage={openDetailEventMessage}
      isOpen={showDrawer}
      onClose={toggleDetailsDrawer}
    >
      <View style={contentStyles.content}>
        <MenuReorderItemsList
          orderEntries={order.orderEntries}
          ListHeaderComponent={() => (
            <MenuReorderCard
              order={order}
              toggleDetailsDrawer={toggleDetailsDrawer}
              drawerIsOpen={showDrawer}
            />
          )}
        />
      </View>
    </BottomSheet>
  );
};
